module.exports = __webpack_public_path__ + "static/media/copy.e1f4c256.svg";